import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import TrustBadges from "./components/TrustBadges";
import CategoryGrid from "./components/CategoryGrid";
import WhyChoose from "./components/WhyChoose";
import FeaturedArticles from "./components/FeaturedArticles";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import CTASection from "./components/CTASection";

const siteUrl = import.meta.env.VITE_SITE_URL;

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <TrustBadges />
        <CategoryGrid />
        <WhyChoose />
        <FeaturedArticles />
        <Testimonials />
        <FAQ />
        <CTASection />
      </main>
      <Footer />

      {/* Organization Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Kakobuy Spreadsheet",
            "url": siteUrl,
            "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png",
            "description": "The best Kakobuy Spreadsheet with verified products, trusted sellers, QC photos, and daily updates for sneakers, clothing, accessories, and designer items.",
            "sameAs": [
              "https://kaspreadsheet.com/"
            ]
          }),
        }}
      />

      {/* WebSite Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "Kakobuy Spreadsheet",
            "url": siteUrl,
            "description": "Discover the best Kakobuy Spreadsheet with verified products, trusted sellers, QC photos, and safe buying guides. Updated daily.",
            "potentialAction": {
              "@type": "SearchAction",
              "target": {
                "@type": "EntryPoint",
                "urlTemplate": siteUrl + "?q={search_term_string}"
              },
              "query-input": "required name=search_term_string"
            }
          }),
        }}
      />

      {/* BreadcrumbList Schema for Home */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": siteUrl
              }
            ]
          }),
        }}
      />
    </>
  );
}